import { Component, computed, input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'app-avatar',
    templateUrl: './avatar.component.html',
    host: { class: 'inline-flex shrink-0 overflow-hidden rounded-full' },
})
export class AvatarComponent {
    readonly name = input.required<string>();

    protected readonly initials = computed(() =>
        this.name()
            .split(' ')
            .filter(Boolean)
            .slice(0, 2)
            .map((part) => part.charAt(0))
            .join('')
            .toUpperCase(),
    );
}
